<template>
    <div class="buy">
        <div class="buy-content-title">
            <van-tabs v-model="active" title-active-color="#246FDD">
                <van-tab title="微信购买">
                    <div class="buy-content-main font14 buy-content-active">
                        <p class="font12">选择套餐</p>
                        <div class="rac borderR">
                            <span>学习有效期{{ expire_time }}天</span>
                            <span class="colord61 font10"
                                >￥<span class="font14">{{
                                    balance
                                }}</span></span
                            >
                            <div><span>√</span></div>
                        </div>
                        <van-button
                            round
                            block
                            type="info"
                            size="small"
                            native-type="submit"
                            color="#246FDD"
                            @click="onSubmit"
                            >支付</van-button
                        >
                    </div>
                </van-tab>
                <!-- <van-tab title="学习卡激活">
                  <div >
                    <van-form @submit="onSubmit">
                      <van-field
                        v-model="username"
                        name="卡号"
                        label="卡号"
                        placeholder="请输入卡号"
                        :rules="[{ required: true, message: '请填写卡号' }]"
                      />
                      <van-field
                        v-model="password"
                        type="password"
                        name="卡号密码"
                        label="卡号密码"
                        placeholder="请输入卡号密码"
                        :rules="[{ required: true, message: '请填写卡号密码' }]"
                      />
                      <div style="margin: 16px">
                        <van-button
                          round
                          block
                          type="info"
                          size="small"
                          native-type="submit"
                          color="#246FDD"
                          >完成</van-button
                        >
                      </div>
                    </van-form>
                  </div>
                </van-tab> -->
            </van-tabs>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: 0,
            username: "",
            password: "",
            appId: "",
            param: {},
            balance: "",
            expire_time: 0,
        };
    },
    created() {
        this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration: 0,
        });
        if (this.$route.query.type == 5) {
            this.$post("/index/Videoedu/buy", {
                video_edu_id: this.$route.query.id,
                type: "JSAPI",
            }).then((res) => {
                this.$toast.clear();
                if (res.code == 200) {
                    this.balance = res.data.balance;
                    this.expire_time = res.data.expire_time;
                    this.appId = res.data.param.appId;
                    this.param = {
                        timestamp: res.data.param.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: res.data.param.nonceStr, // 支付签名随机串，不长于 32 位
                        package: res.data.param.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: res.data.param.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                        paySign: res.data.param.paySign, // 支付签名
                    };
                }
            });
        } else {
            this.$post("/index/Examquestion/buy", {
                exam_question_id: this.$route.query.id,
                type: "JSAPI",
            }).then((res) => {
                this.$toast.clear();
                if (res.code == 200) {
                    this.balance = res.data.balance;
                    this.expire_time = res.data.expire_time;
                    this.appId = res.data.param.appId;
                    this.param = {
                        timestamp: res.data.param.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: res.data.param.nonceStr, // 支付签名随机串，不长于 32 位
                        package: res.data.param.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: res.data.param.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                        paySign: res.data.param.paySign, // 支付签名
                    };
                }
            });
        }
    },
    methods: {
        onSubmit() {
            wx.config({
                appId: this.appId,
            });
            wx.chooseWXPay({
                ...this.param,
                success: (res) => {
                    // 支付成功后的回调函数
                    this.$router.go(-1);
                },
            });
        },
    },
};
</script>

<style lang="less">
.buy {
    .buy-content-title {
        padding-top: 30px;
        .buy-content-active {
            box-sizing: border-box;
            padding: 20px 0;
        }
        .buy-content-main {
            margin-top: 20px;
            box-sizing: border-box;
            padding: 10px 15px;
            & > p {
                font-size: 12px;
                margin-bottom: 10px;
            }
            .borderR {
                border: 1px solid #d61901;
            }
            & > div {
                width: 100%;
                height: 38px;
                box-sizing: border-box;
                padding: 0 20px;
                border: 1px solid #d8d8d8;
                position: relative;
                margin-bottom: 15px;
                & > div {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    width: 0;
                    height: 0;
                    border-left: 15px solid transparent;
                    border-bottom: 15px solid #d61901;
                    color: white;
                    & > span {
                        position: absolute;
                        top: 2px;
                        right: 0;
                        font-size: 10px;
                    }
                }
            }
        }
    }
    .iframeBox {
        z-index: 999;
        position: fixed;
        top: 34px;
        width: 100%;
        height: calc(100vh - 34px);
        background: #fff;
    }
    .van-tabs__wrap {
        border-bottom: 1px solid #ddd;
    }
    .van-tabs__line {
        background-color: #246fdd !important;
    }
}
</style>
